import { addDays } from 'date-fns';

export class UsuarioModel {
  constructor() {
    this.id = undefined;
    this.idColaborador = undefined;
    this.idCliente = undefined;
    this.idUsuarioPerfil = undefined;
    this.login = '';
    this.senha = '';
    this.inativo = false;
    this.usuarioChamadoTipo = [];
  }
}

export class MunicipioModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
    this.uf = '';
    this.codigoIbge = 0;
  }
}

export class BoletoModel {
  constructor() {
    this.id = undefined;
    this.sacadoCpfCnpj = '';
    this.numeroContrato = '';
    this.sacadoNome = '';
    this.sacadoFantasia = '';
    this.codigoBarras = '';
    this.linhaDigitavel = '';
    this.numeroDocumento = '';
    this.vencimento = undefined;
  }
}

export class ModuloModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
    this.descricao = '';
    this.percComissao = 0;
  }
}

export class ArquivoCategoriaModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
  }
}

export class ArquivoSubcategoriaModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
  }
}

export class RevendaModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
  }
}

export class ChamadoTipoModel {
  constructor() {
    this.id = undefined;
    this.tipo = 0;
    this.nome = '';
    this.prazoDias = 1;
    this.permiteTransferencia = false;
  }
}

export class AtualizacaoModel {
  constructor() {
    this.id = undefined;
    this.versao = '';
    this.notas = '';
    this.ativo = true;
    this.file = undefined;
  }
}

export class AtualizacaoLiberacaoModel {
  constructor() {
    this.id = undefined;
    this.idVersao = undefined;
    this.tipoAlvo = 0; // 0=Todos | 1=Perfil | 2=Cliente
    this.idAlvo = 0;
    this.obrigatoria = false;
    this.suspensa = false;
  }
}

export class ColaboradorModel {
  constructor() {
    this.id = undefined;
    this.idRevenda = undefined;
    this.tipo = 0;
    this.nome = '';
    this.telegramChatId = '';
    this.inativo = false;
    this.notificarBackup = false;
    this.notificarChamado = true;
    this.notificarDesenvolvimento = true;
    this.notificarLicenca = false;
  }
}

export class AtendimentoTopicoClassificadorModel {
  constructor() {
    this.id = undefined;
    this.descricao = '';
  }
}
export class AtendimentoClassificacaoModel {
  constructor() {
    this.id = undefined;
    this.descricao = '';
    this.idAtendTopicoClassificador = undefined;
    this.grauComplexidade = 0;
    this.tempoEstimado = 0;
    this.permiteAlterarDescricao = false;
    this.atendTopicoClassificador = undefined;
  }
}

export class ChamadoModel {
  constructor() {
    this.id = undefined;
    this.idUsuario = undefined;
    this.idRevenda = undefined;
    this.idCliente = undefined;
    this.idChamadoTipo = 1;
    this.idColaborador = undefined;
    this.status = 0;
    this.dataLancamento = new Date();
    this.horaLancamento = new Date();
    this.prazoDias = 1;
    this.descricao = '';
    this.observacaoAtendente = '';
    this.dataFechamento = null;
    this.horaFechamento = null;
    this.contato = '';
    this.solicitadoPor = 1;
    this.idChamado = null;
    this.chamadoClassificacao = [];
    this.cliente = {
      clienteContatoEndereco: {
        celular: '',
        fone: '',
      },
    };
  }
}

export class EdicaoModel {
  construcotr() {
    this.id = undefined;
    this.codigo = 0;
    this.nome = '';
    this.percSalario = 0;
    this.percAcessoAdicional = 0;
    this.qtdAcessoIncluso = 0;
  }
}
export class SistemaEdicaoModel {
  constructor() {
    this.id = undefined;
    this.idSistema = undefined;
    this.idEdicao = undefined;
    this.percSalario = 0;
    this.percAcessoAdicional = 0;
    this.qtdAcessoIncluso = 0;
    this.edicao = new EdicaoModel();

    /** @type {SistemaEdicaoModuloModel[]} */
    this.sistemaEdicaoModulo = [];
  }
}

export class SistemaModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
    this.descricao = '';
    /** @type {SistemaEdicaoModel[]} */
    this.sistemaEdicao = [];
  }
}

export class SistemaEdicaoModuloModel {
  constructor() {
    this.id = undefined;
    this.idSistemaEdicao = undefined;
    this.idModulo = undefined;
    this.percentual = 0;
    this.tipoCobranca = 0;
    this.qtdAcessoIncluso = 10;
    this.modulo = new ModuloModel();
  }
}

export class DesenvolvimentoModel {
  constructor() {
    this.id = undefined;
    this.idCliente = undefined;
    this.idColaboradorResponsavel = undefined;
    this.idSistema = undefined;
    this.idColaboradorProgramador = undefined;
    this.colaboradorResponsavel = new ColaboradorModel();
    this.sistema = new SistemaModel();
    this.colaboradorProgramador = new ColaboradorModel();
    this.dataLancamento = new Date();
    this.dataPrevisao = null;
    this.dataInicioDesenv = null;
    this.dataConclusao = null;
    this.status = 0;
    this.descricaoSolicitacao = '';
    this.descricaoDesenvolvimento = '';
    this.historicoVersao = '';
    this.versaoLiberacao = '';
    this.prioridade = 2;
    this.descricaoResumida = '';
    this.testado = false;
    this.roteiroTestes = '';
    this.observacao = '';

    this.desenvolvimentoCliente = [];
  }
}

export class ClienteContatoEndereco {
  constructor() {
    this.id = undefined;
    this.idCliente = undefined;
    this.idMunicipio = undefined;
    this.nomeContato = '';
    this.cep = '';
    this.logradouro = '';
    this.numero = '';
    this.complemento = '';
    this.bairro = '';
    this.fone = '';
    this.celular = '';
    this.email = '';
  }
}

export class DesenvolvimentoArquivo {
  constructor() {
    this.id = undefined;
    this.idDesenvolvimento = undefined;
    this.nome = '';
    this.file = undefined;
    this.data = new Date();
  }
}

export class ChamadoArquivo {
  constructor() {
    this.id = undefined;
    this.idChamado = undefined;
    this.nome = '';
    this.file = undefined;
    this.data = new Date();
  }
}

export class DesenvolvimentoTeste {
  constructor() {
    this.id = undefined;
    this.idDesenvolvimento = undefined;
    this.idColaborador = undefined;
    this.colaborador = new ColaboradorModel();
    this.data = new Date();
    this.situacao = 0;
    this.descricao = '';
  }
}

export class ClienteModel {
  constructor() {
    this.id = undefined;
    this.numeroContrato = null;
    this.nome = '';
    this.versaoSistema = null;
    this.numeroDispositivos = null;
    this.nomeFantasia = '';
    this.edicao = null;
    this.cpfCnpj = '';
    this.tipoPessoa = 'J';
    this.inscricaoEstadual = '';
    this.diaVencimento = null;
    this.percentualSalario = null;
    this.valorImplantacao = null;
    this.observacao = '';
    this.nomeContato = '';
    this.dataInicioContrato = null;
    this.dataFimContrato = null;
    this.inativo = false;
    this.perfilAtualizacao = 2;
    this.idRevenda = null;
    this.idClientePrincipal = null;
    this.valorSalarioBase = 0;
    this.valorMensal = 0;
    this.revenda = new RevendaModel();
    this.sistema = new SistemaModel();
    this.dataInclusao = new Date();
    this.idSistema = 1; // gerencial
    this.percentualSalarioCalculado = 0;
    this.edicaoPerSalario = 0;
    this.edicaoPercAcessoAdicional = 0;
    this.edicaoQtdAcessoIncluso = 0;

    this.chave = new ChaveModel();
    /** @type {ClienteSocioModel[]} */
    this.socios = [];
    /** @type {ModuloModel[]} */
    this.modulos = [];

    this.clienteContatoEndereco = new ClienteContatoEndereco();
  }
}

export class ChaveVencimento {
  constructor() {
    this.numeroContrato = '';
    this.vencimento = undefined;
    this.edicao = '0';
    this.qtdDispositivos = 1;
    this.chaveLiberacao = '';
    this.modulos = {};
    this.justificativa = ''; // campo apenas para auditoria
  }
}

export class ChaveDispositivo {
  constructor() {
    this.chaveDispositivo = '';
    this.processador = '';
    this.numeroContrato = '';
    this.hd = '';
    this.contraChaveDispositivo = '';
    this.md5 = '';
    this.justificativa = ''; // campo apenas para auditoria
  }
}

export class ClienteModuloModel {
  constructor() {
    this.id = undefined;
    this.idCliente = null;
    this.idModulo = null;
    this.quantidade = 0;
    this.percencual = 0;
    this.qtdAcessoIncluso = 0;
  }
}

export class ClienteSocioModel {
  constructor() {
    this.id = undefined;
    this.idCliente = null;
    this.nome = '';
    this.cpf = '';
    this.email = '';
    this.celular1 = '';
    this.celular2 = '';
  }
}

export class ChaveModel {
  constructor() {
    this.id = undefined;
    this.numeroContrato = undefined;
    this.chaveLiberacao = '';
    this.vencimento = null;
  }
}

export class OrcamentoCabecalhoModel {
  constructor() {
    this.id = undefined;

    this.revenda = new RevendaModel();
    this.sistema = new SistemaModel();

    /** @type {ModuloModel[]} */
    this.modulos = [];
    this.idMunicipio = undefined;
    this.idUsuario = undefined;
    this.idRevenda = undefined;
    this.idSistema = undefined;
    this.dataLancamento = new Date();
    this.dataValidade = addDays(new Date(), 15);
    this.cpfCnpj = '';
    this.tipoPessoa = 'J';
    this.nome = '';
    this.contato = '';
    this.edicao = 0;
    this.numeroDispositivos = 1;
    this.valorSalarioBase = 0;
    this.edicaoPercSalario = 0;
    this.edicaoQtdAcessoIncluso = 0;
    this.edicaoPercAcessoUltrapassado = 0;
    this.modulosPercSalario = 0;
    this.percentualSalario = 0;
    this.percentualSalarioCalculado = 0;
    this.valorImplantacao = 0;
    this.valorMensal = 0;
    this.fone = '';
    this.observacao = '';
  }
}

export class CampanhaModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
    this.descricao = '';
    this.inativo = false;
  }
}

export class AcompanhamentoVendaModel {
  constructor() {
    this.id = undefined;
    this.idColaborador = undefined;
    this.idCampanha = undefined;
    this.idMunicipio = undefined;
    this.dataLancamento = new Date();
    this.dataContato = null;
    this.status = 0;
    this.pessoaContato = '';
    this.razaoSocial = '';
    this.dataProximoContato = new Date();
    this.email = '';
    this.logradouro = '';
    this.bairro = '';
    this.cnpj = '';
    this.cep = '';
    this.idRevenda = undefined;
    this.colaborador = undefined;
    this.revenda = undefined;
    this.acompanhamentoVendaHistorico = [];
    this.acompanhamentoVendaTelefone = [];
  }
}

export class AuditoriaModel {
  constructor() {
    this.id = undefined;
    this.idUsuario = null;
    this.dataRegistro = null;
    this.horaRegistro = null;
    this.acao = '';
    this.conteudo = '';
    this.pagina = '';
    this.usuario = new UsuarioModel();
  }
}

export class FuncaoModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
    this.nomeAgrupamento = '';
    this.descricao = '';
  }
}

export class UsuarioPerfilFuncaoModel {
  constructor() {
    this.id = undefined;
    this.idUsuarioPerfil = null;
    this.idFuncao = null;
    this.ativo = false;
    this.funcao = new FuncaoModel();
  }
}

export class UsuarioPerfilModel {
  constructor() {
    this.id = undefined;
    this.nome = '';
    this.usuarioPerfilDetalhe = [];
  }
}

export class VersaoSistemaModel {
  constructor() {
    this.id = undefined;
    this.idSistema = 1;
    this.data = new Date();
    this.versao = '';
    this.historico = '';
    this.disponivel = false;
    this.sistema = new SistemaModel();
  }
}

export class GerenciadorArquivoModel {
  constructor() {
    this.id = undefined;
    this.idArquivoCategoria = undefined;
    this.idArquivoSubcategoria = undefined;
    this.nomeArquivo = undefined;
    this.descricao = undefined;
    this.data = new Date();
  }
}
